import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * Confirms removing a contract template. Soft delete, so contracts already made from this
 * template keep working - they carry their own copy of the wording's outcome (the
 * generated PDF) and the backend only reads the template while composing a NEW contract.
 */
function ContractTemplateDeleteDialog({ open, name, onCancel, onConfirm, working }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Poistetaanko sopimusmalli?</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          <b>{name || ''}</b>
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Malli poistuu valittavista, eikä sillä voi enää tehdä uusia sopimuksia. Jo tehdyt sopimukset
          jäävät voimaan sellaisinaan.
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Jos malli on vain hetkellisesti pois käytöstä, ota se mieluummin pois käytöstä muokkausnäkymässä
          — silloin se säilyy listalla.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={working}>
          Peruuta
        </Button>
        <Button onClick={onConfirm} variant='contained' color='error' disabled={working}>
          {working ? 'Poistetaan...' : 'Poista'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ContractTemplateDeleteDialog
